export const modals = {
  common: {
    ok: 'კარგი',
    close: 'დახურვა',
    okay: 'კარგი',
  },
  minimumAge: {
    title: 'ასაკის შეზღუდვა',
    message: 'უნდა იყოთ მინიმუმ {{age}} წლის.',
  },
  accountBlocked: {
    title: 'ანგარიში დაბლოკილია',
    heading: 'ანგარიში დაბლოკილია',
    permanent: 'ეს ანგარიში მუდმივად დაბანებულია.',
    temporary: 'ეს ანგარიში დაბანებულია.',
    temporaryUntil: 'ანგარიში დაბლოკილია {{date}}-მდე.',
    reason: 'მიზეზი: {{reason}}',
  },
  insufficientBalance: {
    title: 'არასაკმარისი თანხა',
    description: 'შეავსეთ ბალანსი და დაბრუნდით თამაშში.',
    cta: 'ბალანსის შევსება',
  },
  chestNotPlayed: {
    title: 'დღიური ჯილდო დაბლოკილია',
    heading: 'მოდი ვითამაშოთ',
    description:
      'დღევანდელ ყუთის გასახსნელად თამაში მაინც ერთხელ უნდა ჩათამაშოთ.',
    cta: 'თამაში ახლა',
  },
  chestAlreadyOpened: {
    title: 'ხვალ კიდევ მოდი',
    message: 'დღევანდელი ყუთი უკვე გახსენი.',
  },
  chestUnlocked: {
    title: 'ჯილდო გახსნილია',
    modalDescription:
      'თქვენ მოიპოვეთ ჯილდო! ახლავე გახსენით ყუთი და ნახეთ, რა გელოდებათ შიგნით.',
    heading: 'ჯილდო გახსნილია',
    description:
      'თქვენ მოიპოვეთ ჯილდო! ახლავე გახსენით ყუთი და ნახეთ, რა გელოდებათ შიგნით.',
    cta: 'ჯილდოებზე გადასვლა',
  },
  paymentResult: {
    successTitle: 'გადახდა წარმატებულია',
    successDescription: 'გადახდა წარმატებით დასრულდა.',
    failureTitle: 'გადახდა ვერ მოხერხდა',
    failureDescription: 'გადახდა არ დასრულდა. სცადეთ ხელახლა.',
  },
  winMore: {
    title: 'გსურთ მეტი მოგება?',
    heading: 'გსურთ მეტი მოგება?',
    description:
      'უფრო მაღალი შესვლის ფასი - უფრო დიდი მოგება. შეავსეთ ბალანსი უფრო მაღალი ლიგის თამაშისთვის.',
    cta: 'თანხის დამატება',
  },
  winRealMoney: {
    title: 'გსურთ ნამდვილი ფული მოიგოთ?',
    heading: 'გსურთ ნამდვილი ფული მოიგოთ?',
    description:
      'უბრალოდ შეავსეთ საფულე და ითამაშეთ ნამდვილ მოწინააღმდეგეებთან. დაიწყეთ მოგება ახლავე!',
    cta: 'ბალანსის შევსება',
  },
  goPlay: {
    title: 'დავიწყოთ თამაში',
    heading: 'დავიწყოთ თამაში',
    subtitle: 'აირჩიეთ თამაში და დაიწყეთ წამებში',
  },
};
